import Header from '@/components/Header';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Mail, MessageCircle } from 'lucide-react';
import SEOHelmet from '@/components/SEOHelmet';

export default function ObrigadoEspera() {
  return (
    <div className="min-h-screen bg-black">
      <SEOHelmet />
      <Header />
      
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
            <h1 className="text-4xl font-bold text-white mb-4">
              Cadastro Realizado com Sucesso!
            </h1>
            <p className="text-xl text-slate-300">
              Você foi incluído na lista de prioridade para o Copy Trade
            </p>
          </div>

          <Card className="mb-8 bg-slate-900 border-slate-700">
            <CardContent className="p-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <Mail className="w-6 h-6 text-cyan-400 mt-1 flex-shrink-0" />
                  <div className="text-left">
                    <h3 className="font-semibold text-lg mb-2 text-white">Verifique seu E-mail</h3>
                    <p className="text-slate-300">
                      Um e-mail de confirmação foi enviado para você e deve chegar a qualquer momento. 
                      Se não encontrar na caixa de entrada, <strong className="text-white">verifique as pastas de Promoções 
                      ou Spam</strong>.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <MessageCircle className="w-6 h-6 text-cyan-400 mt-1 flex-shrink-0" />
                  <div className="text-left">
                    <h3 className="font-semibold text-lg mb-2 text-white">Próximos Passos</h3>
                    <p className="text-slate-300 mb-4">
                      Para não perder a próxima janela de oportunidade e receber atualizações 
                      exclusivas, entre em nossa comunidade no WhatsApp:
                    </p>
                    <Button
                      asChild
                      className="w-full sm:w-auto bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold px-8 py-3 text-lg"
                    >
                      <a 
                        href="https://rebrand.ly/ComunidadeWhatsapp" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="flex items-center gap-2"
                      >
                        <MessageCircle className="w-5 h-5" />
                        Entrar na Comunidade WhatsApp
                      </a>
                    </Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="bg-cyan-500/10 border border-cyan-400/30 rounded-lg p-6">
            <h3 className="font-semibold text-lg mb-2 text-cyan-400">
              🎯 Você está na Lista de Prioridade!
            </h3>
            <p className="text-slate-300">
              Assim que abrirmos novas vagas para o Copy Trade, você será um dos primeiros 
              a ser notificado. Fique atento ao seu e-mail e WhatsApp!
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}